{
  "pages": {
    "ChallengeDispute": {
      "challenge_dispute": "Challenge dispute",
      "challenge_details": "Challenge details",
      "challenge_reason": "Challenge reason",
      "supporting_evidence": "Supporting evidence",
      "transaction_details": "Transaction details",
      "order_details": "Order details",
      "customer_details": "Customer details",
      "other_evidence": "Other evidence",
      "other_supporting_documents": "Other supporting documents",
      "your_responses_will_help_us_recommend": "Your responses will help us recommend the best evidence to\n                      submit for your challenge.",
      "dispute_id": "Dispute ID:",
      "view_details": "View details",
      "dispute_amount": "Dispute amount",
      "response_due": "Response due",
      "due_in_1_hour": "Due in 1 hour",
      "why_are_you_challenging_the_dispute": "Why are you challenging the dispute?",
      "choose_the_closest_option": "Choose the closest option.",
      "the_customer_withdrew_the_dispute": "The customer withdrew the dispute",
      "the_customer_has_already_been_refunded": "The customer has already been refunded",
      "the_customer_has_a_purchasing_history": "The customer has a purchasing history with me",
      "other_reasons": "Other reasons",
      "what_type_of_productservice_was_the": "What type of product/service was the disputed payment for?",
      "physical_product": "Physical product",
      "physical_goods_to_be_delivered_to": "Physical goods to be delivered to the customer, e.g.\n                            clothes, accessories, electronic gadgets",
      "digital_product_or_service": "Digital product or service",
      "purchased_access_to_software_digital_files": "Purchased access to software, digital files or\n                            experiences, e.g. mobile apps, music service,\n                            digital tickets",
      "offline_service": "Offline service",
      "labour_or_assistant_services_provided_either": "Labour or assistant services provided either at a\n                            specific location or remotely, e.g. transportation,\n                            home servicing",
      "reservation_or_booking": "Reservation or booking",
      "services_related_to_reservations_or_bookings": "Services related to reservations or bookings, e.g.\n                            flight tickets, hotel booking",
      "other": "Other",
      "cancel": "Cancel",
      "next": "Next",
      "recommended_evidence": "Recommended evidence",
      "based_on_your_challenge_reason_we": "Based on your challenge reason, we recommend providing:",
      "provide_supporting_evidence": "Provide supporting evidence",
      "upload_file": "Upload file",
      "attrs": {
        "include_any_additional_file_descriptions_or": "Include any additional file descriptions or explanations here. (Optional)"
      },
      "i_do_not_have_any_evidence": "I do not have any evidence to provide for this step",
      "back": "Back",
      "please_provide_as_much_information_as": "Please provide as much information as possible about the\n                      goods/service the payment was disputed for. This will\n                      allow the issuer to verify that the evidence you provided\n                      corresponds to the transaction disputed by the customer.",
      "the_details_below_have_been_prefilled": "The details below have been pre-filled from transaction\n                      data. Please review and edit the information if needed.",
      "product_details": "Product details",
      "iphone7_5": "IPHONE7 * 5,",
      "shipping_address": "Shipping address",
      "shipping_carrier": "Shipping carrier",
      "sameday": "sameday",
      "provide_additional_supporting_evidence": "Provide additional supporting evidence",
      "as_the_payment_was_for_a": "As the payment was for a",
      "we_recommend_you_to_also_provide": ", we\n                      recommend you to also provide the following information:",
      "shipping_date": "Shipping date",
      "shipping_tracking_number": "Shipping tracking number",
      "you_can_upload_any_document_containing": "You can upload any document containing such information\n                      (e.g. invoices, shipping documentation, delivery\n                      confirmation or shipping receipts) below.",
      "please_provide_as_much_information_as_2": "Please provide as much information as possible about the\n                      customer. This will allow the issuer to verify that the\n                      evidence you provided corresponds to the customer\n                      disputing the transaction.",
      "customer_name": "Customer name",
      "test_name": "Test name",
      "customer_email": "Customer email",
      "customerexamplecom": "customer@example.com",
      "customer_purchase_ip": "Customer purchase IP",
      "customer_billing_address": "Customer billing address",
      "we_recommend_you_to_provide_the": "We recommend you to provide the following information\n                      about the customer:",
      "you_can_upload_any_document_containing_2": "You can upload any document containing such information\n                      (e.g. invoices, receipts) below.",
      "if_you_have_any_other_documents": "If you have any other document(s) that you believe is\n                      valuable to assess the legitimacy of your challenge, you\n                      can add it below.",
      "review": "Review",
      "review_your_challenge": "Review your challenge",
      "please_confirm_that_the_information_you": "Please confirm that the information you have provided is\n                      correct before submission.",
      "reason_for_challenge": "Reason for challenge",
      "type_of_product_or_service": "Type of product or service",
      "please_attach_at_least_one_of": "Please attach at least one of the recommended evidence\n                        types to proceed with the response.",
      "i_understand_that_the_current_evidence": "I understand that the current evidence can only be\n                        submitted once for the issuer's review, and cannot be\n                        reused.",
      "submit": "Submit",
      "your_dispute_challenge_has_been_submitted": "Your dispute challenge has been submitted.",
      "thank_you_for_submitting_your_information": "Thank you for submitting your information. The issuing bank\n                    will review your challenge and make a decision within 115\n                    days. We will notify you on any updates along the process.",
      "dispute_challenge": "Dispute challenge",
      "no_files_uploaded": "No files uploaded",
      "view_all_disputes": "View all Disputes",
      "back_to_dispute_details": "Back to Dispute details",
      "are_you_sure_you_want_to": "Are you sure you want to proceed without evidence?",
      "submitting_a_challenge_without_supporting_evidence": "Submitting a challenge without supporting evidence\n                      significantly reduces your chances of winning the dispute.\n                      We strongly recommend providing at least one type of\n                      evidence to support your case.",
      "go_back_and_add_evidence": "Go back and add evidence",
      "proceed_anyway": "Proceed anyway"
    },
    "DisputeDetail": {
      "pomelo_pay": "Bank of Maldives",
      "your_responses_will_help_us_recommend": "Your responses will help us recommend the best evidence\n                        to submit for your challenge.",
      "we_recommend_this_reason_as_we": "We recommend this reason as we have identified\n                                  transactions that prove the customer has a\n                                  purchasing history with you.",
      "what_type_of_productservice_was_the": "What type of product/service was the disputed payment\n                        for?",
      "physical_goods_to_be_delivered_to": "Physical goods to be delivered to the customer,\n                              e.g. clothes, accessories, electronic gadgets",
      "purchased_access_to_software_digital_files": "Purchased access to software, digital files or\n                              experiences, e.g. mobile apps, music service,\n                              digital tickets",
      "labour_or_assistant_services_provided_either": "Labour or assistant services provided either at a\n                              specific location or remotely, e.g.\n                              transportation, home servicing",
      "services_related_to_reservations_or_bookings": "Services related to reservations or bookings, e.g.\n                              flight tickets, hotel booking",
      "for_visa_132_subscription_canceled_disputes": "For Visa 13.2 (Subscription Canceled) disputes, we\n                        recommend you provide the following evidence:",
      "for_subscription_cancellation_disputes_we_recommend": "For subscription cancellation disputes, we recommend\n                          you provide the following evidence:",
      "please_provide_as_much_information_as": "Please provide as much information as possible about the\n                        goods/service the payment was disputed for. This will\n                        allow the issuer to verify that the evidence you\n                        provided corresponds to the transaction disputed by the\n                        customer.",
      "the_details_below_have_been_prefilled": "The details below have been pre-filled from transaction\n                        data. Please review and edit the information if needed.",
      "iphone7_5_10001_usd": "IPHONE7 * 5, 100.01 MVR",
      "pomelo_pay_office_1_raffles_place": "BML Head Office, Boduthakurufaanu Magu,\n                          Malé 20094, Maldives",
      "we_recommend_you_to_also_provide": ",\n                        we recommend you to also provide the following\n                        information:",
      "you_can_upload_any_document_containing": "You can upload any document containing such information\n                        (e.g. invoices, shipping documentation, delivery\n                        confirmation or shipping receipts) below.",
      "please_provide_as_much_information_as_2": "Please provide as much information as possible about the\n                        customer. This will allow the issuer to verify that the\n                        evidence you provided corresponds to the customer\n                        disputing the transaction.",
      "jessicapomelopaycom": "jessica@bankofmaldives.com.mv",
      "customer_phone": "Customer phone",
      "we_recommend_you_to_provide_the": "We recommend you to provide the following information\n                        about the customer:",
      "you_can_upload_any_document_containing_2": "You can upload any document containing such information\n                        (e.g. invoices, receipts) below.",
      "if_you_have_any_other_documents": "If you have any other document(s) that you believe is\n                        valuable to assess the legitimacy of your challenge, you\n                        can add it below.",
      "please_confirm_that_the_information_you": "Please confirm that the information you have provided is\n                        correct before submission.",
      "pomelo_pay_office_1_raffles_place_2": "BML Head Office, Boduthakurufaanu Magu,\n                            Malé 20094, Maldives",
      "please_attach_at_least_one_of": "Please attach at least one of the recommended evidence\n                          types to proceed with the response.",
      "i_understand_that_the_current_evidence": "I understand that the current evidence can only be\n                          submitted once for the issuer's review, and cannot be\n                          reused.",
      "submitting_a_challenge_without_supporting_evidence": "Submitting a challenge without supporting evidence\n                        significantly reduces your chances of winning the\n                        dispute. We strongly recommend providing at least one\n                        type of evidence to support your case.",
      "back_to_disputes": "Back to Disputes",
      "dispute": "Dispute",
      "challenge_submitted": "Challenge submitted",
      "your_challenge_has_been_submitted_and": "Your challenge has been submitted and is being reviewed by the\n                  issuing bank. You will be notified of any updates.",
      "view_challenge_details": "View challenge details",
      "dispute_won": "Dispute won",
      "the_issuing_bank_has_reviewed_your": "The issuing bank has reviewed your evidence and ruled in your\n                  favor. The disputed amount has been credited back to your\n                  account.",
      "view_your_submitted_evidence": "View your submitted evidence",
      "dispute_reversed": "Dispute reversed",
      "the_cardholder_has_withdrawn_their_dispute": "The cardholder has withdrawn their dispute. The disputed\n                  amount has been credited back to your account.",
      "dispute_accepted": "Dispute accepted",
      "you_have_accepted_this_dispute_the": "You have accepted this dispute. The disputed amount will not\n                  be credited back to your account.",
      "dispute_lost": "Dispute lost",
      "the_issuing_bank_has_reviewed_your_2": "The issuing bank has reviewed your evidence and ruled in favor\n                  of the cardholder. The disputed amount will not be credited\n                  back to your account.",
      "due_in": "Due in",
      "challenge_this_dispute_with_customers_purchasing": "Challenge this dispute with customer's purchasing history.",
      "we_have_identified_matching_transactions_that": "We have identified matching transactions that prove this\n                      customer has a purchasing history with you (see",
      "related_orders": "Related orders",
      "you_can_challenge_this_dispute_by": "). You can challenge this dispute by providing additional\n                      details about these matching transactions.",
      "reason": "Reason",
      "network_reason_code": "Network reason code",
      "dispute_stage": "Dispute stage",
      "dispute_time": "Dispute time",
      "transaction_type": "Transaction type",
      "payment": "Payment",
      "issuer_comments": "Issuer comments",
      "recall": "Recall",
      "challenge": "Challenge",
      "accept": "Accept",
      "attrs": {
        "tabs": "Tabs",
        "copy_order_id": "Copy Order ID",
        "add_a_note_for_internal_reference": "Add a note for internal reference...",
        "describe_any_communication_with_the_customer": "Describe any communication with the customer...",
        "tracking_numbers_delivery_confirmation_etc": "Tracking numbers, delivery confirmation, etc..."
      },
      "payment_summary": "Payment summary",
      "order_id": "Order ID",
      "copied": "Copied!",
      "source": "Source",
      "payment_type": "Payment type",
      "debit_card": "Debit card",
      "payment_method": "Payment method",
      "cardholder_name": "Cardholder name",
      "security_checks": "Security checks",
      "card_security_code": "Card security code",
      "3ds": "3DS",
      "billing_address_verification": "Billing address verification",
      "view_payment_details": "View payment details",
      "customers_may_have_a_purchasing_history": "Customers may have a purchasing history with you, which could be\n              used as evidence to challenge the claim that there is a fraudulent\n              charge. To help you define this history, we have identified orders\n              that qualify as",
      "matching_transactions_to_the_issuer": "matching transactions to the issuer",
      "to_qualify_as_a_matching_transaction": "To qualify as a matching transaction to the issuer, a\n                        transaction must meet the following criteria:",
      "at_least_two_data_elements_ip": "At least two data elements (IP address, device ID /\n                          fingerprint, shipping address, email address) must\n                          match across all three transactions, and one of these\n                          two must be the IP address or device ID or fingerprint",
      "between_120_and_365_days_older": "Between 120 and 365 days older than the date of the\n                          disputed transaction",
      "undisputed_and_not_have_been_reported": "Undisputed, and not have been reported as fraudulent",
      "we_also_show_you_if_the": "We also show you if the payment method matches, which\n                        can be used to support your challenge.",
      "amount": "Amount",
      "created_time": "Created Time",
      "status": "Status",
      "matching_criteria": "Matching Criteria",
      "of": "of",
      "criteria": "criteria",
      "rows_per_page": "Rows per page:",
      "payment_breakdown": "Payment breakdown",
      "payment_amount": "Payment amount",
      "final_disputed_amount": "Final disputed amount",
      "dispute_fee": "Dispute fee",
      "net_amount": "Net amount",
      "recent_activity": "Recent Activity",
      "add_note": "Add note",
      "internal_note": "Internal Note",
      "save": "Save",
      "by": "by",
      "edit": "Edit",
      "delete": "Delete",
      "you_are_challenging_the_dispute": "You are challenging the dispute",
      "heres_a_preview_of_what_will": "Here's a preview of what will happen next:",
      "you_submit_the_challenge": "You submit the challenge",
      "well_guide_you_to_provide_the": "We'll guide you to provide the most compelling evidence\n                        to support your challenge.",
      "issuer_reviews_the_evidence_decides_on": "Issuer reviews the evidence & decides on next steps",
      "if_the_issuer_is_convinced_by": "If the issuer is convinced by the submitted evidence,\n                        the disputed amount will be credited back to you with\n                        the next settlement batch. Please note that the\n                        chargeback fee will not be credited to you.",
      "if_they_are_not_convinced_by": "If they are not convinced by the submitted evidence,\n                        they will decline the evidence and the dispute will be\n                        lost. No further action is possible.",
      "submit_evidence": "Submit Evidence",
      "customer_communication": "Customer Communication",
      "shippingdelivery_documentation": "Shipping/Delivery Documentation",
      "upload_supporting_documents": "Upload Supporting Documents",
      "drag_and_drop_files_here_or": "Drag and drop files here, or click to browse",
      "pdf_jpg_png_up_to_10mb": "PDF, JPG, PNG up to 10MB each",
      "related_order": "Related Order",
      "order": "Order",
      "matching_criteria_2": "Matching criteria",
      "payment_created_time": "Payment created time",
      "0901_utc0800": "09:01 UTC+0800",
      "card_type": "Card type",
      "credit": "CREDIT",
      "visa": "visa",
      "visa_9400": "Visa •••• 9400",
      "auto_testing": "Auto Testing",
      "payment_security_check": "Payment security check",
      "close": "Close",
      "ohmmcairospecsshe9jul25pdf": "OHMM-Cairo-Specs-She...9Jul25.pdf",
      "104_mb": "1.04 MB",
      "customerpomelopaycom": "customer@bankofmaldives.com.mv",
      "the_disputed_amount_will_be_credited": "The disputed amount will be credited back to your\n                          wallet in the next settlement batch. You can view the\n                          settlement details in the \"Dispute settlement\" section\n                          of the payment details page.",
      "if_you_agree_that_the_dispute": "If you agree that the dispute reason is valid, it is\n                          best to accept the dispute.",
      "if_the_customer_agrees_to_withdraw": "If the customer agrees to withdraw the dispute, you\n                          still need to challenge the dispute and submit the\n                          agreement as supporting evidence.",
      "if_the_customer_is_upholding_the": "If the customer is upholding the dispute but you\n                          believe it is not valid, consider whether you have\n                          compelling evidence to challenge the dispute with.",
      "note_that_challenging_the_dispute_can": "Note that challenging the dispute can lead to higher\n                        fees if the issuer is not convinced by your evidence.",
      "review_the_dispute_details_and_if": "Review the dispute details and if necessary contact\n                          your customer to understand why they filed the\n                          dispute.",
      "accept_this_dispute": "Accept this dispute?",
      "accepting_this_dispute_is_final_once": "Accepting this dispute is final. Once you accept, the\n                      customer will receive a refund of",
      "the_funding_timelines_can_vary_by": ". The funding timelines\n                      can vary by the issuer.",
      "accept_dispute": "Accept dispute",
      "add_note_2": "Add Note",
      "note": "Note"
    },
    "getDaysLeftBadge": {
      "overdue_by": "Overdue by",
      "due_in_less_than_1_hour": "Due in less than 1 hour",
      "hours": "hours",
      "left": "left",
      "days_left": "days left"
    },
    "Disputes": {
      "requires_response": "Requires response",
      "challenged": "Challenged",
      "all_disputes": "All disputes",
      "won_or_reversed": "Won or Reversed",
      "accepted_or_lost": "Accepted or Lost",
      "attrs": {
        "search_by_dispute_id_transaction_id": "Search by dispute ID, transaction ID, or customer..."
      },
      "all_stages": "All Stages",
      "rfi": "RFI",
      "prechargeback": "Pre-chargeback",
      "chargeback": "Chargeback",
      "prearbitration": "Pre-arbitration",
      "arbitration": "Arbitration",
      "all_statuses": "All Statuses",
      "expired": "Expired",
      "accepted": "Accepted",
      "reversed": "Reversed",
      "pending_closure": "Pending Closure",
      "pending_decision": "Pending Decision",
      "won": "Won",
      "lost": "Lost",
      "all_reasons": "All Reasons",
      "duplicate": "Duplicate",
      "fraudulent": "Fraudulent",
      "subscription_canceled": "Subscription canceled",
      "product_unacceptable": "Product unacceptable",
      "product_not_received": "Product not received",
      "unrecognized": "Unrecognized",
      "credit_not_processed": "Credit not processed",
      "incorrect_account_details": "Incorrect account details",
      "insufficient_funds": "Insufficient funds",
      "bank_cannot_process": "Bank cannot process",
      "debit_not_authorized": "Debit not authorized",
      "general": "General",
      "customer_initiated": "Customer initiated",
      "check_returned": "Check returned",
      "noncompliant": "Noncompliant",
      "all_payment_methods": "All Payment Methods",
      "card": "Card",
      "bank_transfer": "Bank Transfer",
      "wallet": "Wallet",
      "filter_by": "Filter by",
      "disputed_time": "Disputed time",
      "last_updated": "Last updated",
      "from": "From",
      "to": "To",
      "clear_dates": "Clear dates",
      "dispute": "dispute",
      "selected": "selected",
      "clear_selection": "Clear selection",
      "accept_selected": "Accept selected",
      "response_due": "Response Due",
      "disputed_amount": "Disputed Amount",
      "stage": "Stage",
      "payment_method": "Payment Method",
      "customer": "Customer",
      "actions": "Actions",
      "lkr": "LKR",
      "no_disputes_found": "No disputes found",
      "no_disputes_match_your_current_search": "No disputes match your current search criteria. Try adjusting your\n              filters.",
      "accepting": "Accepting",
      "is_final_once_you_accept_the": "is final. Once you accept, the customer",
      "will_receive_a_refund_the_funding": "will receive a\n                      refund. The funding timelines can vary by the issuer."
    }
  }
}
